import { useState, useEffect, useCallback } from 'react';
import { operators } from 'services';
import { skeletonFactory, useHandleRequest } from 'shared';

const operatorDummy = skeletonFactory.operator();

export function useOperator(id) {
  const [operatorData, setOperatorData] = useState(id ? operatorDummy : {});
  const { request, errorInfo, setErrorInfo } = useHandleRequest();

  useEffect(() => {
    async function getData() {
      await request(async () => {
        const response = await operators.getById(id);
        if (response) {
          setOperatorData(response.data || {});
        }
      }, false);
    }
    id && getData();
  }, [request, id]);

  const updateOperator = useCallback(
    async operator => {
      await request(async () => {
        setOperatorData(operator);
        await operators.update(id, operator);
      });
    },
    [request, id]
  );

  const createOperator = useCallback(
    async operator => {
      await request(async () => {
        setOperatorData(operator);
        await operators.create(operator);
      });
    },
    [request]
  );

  return {
    operator: operatorData,
    errorInfo,
    setErrorInfo,
    setOperatorData,
    createOperator,
    updateOperator
  };
}
